import React, { useEffect, useState } from 'react';
import styles from './Style.module.css';
import Skeleton from 'react-loading-skeleton';

const SM = '(min-width: 575px)';
const MD = '(min-width: 767px)';
const LG = '(min-width: 992px)';

const getSkeletonCount = (matchesSM, matchesMD, matchesLG) => {
  if (matchesLG) return 8;
  if (matchesMD) return 7;
  if (matchesSM) return 6;
  return 5;
};

const BookingDatesPickerLoader = () => {
  const [skeletonCount, setSkeletonCount] = useState(() => {
    if (typeof window === 'undefined') return 8;
    return getSkeletonCount(window.matchMedia(SM).matches, window.matchMedia(MD).matches, window.matchMedia(LG).matches);
  });

  useEffect(() => {
    const mediaQueryListSM = window.matchMedia(SM);
    const mediaQueryListMD = window.matchMedia(MD);
    const mediaQueryListLG = window.matchMedia(LG);

    const updateSkeletonCount = () => {
      const nextCount = getSkeletonCount(
        mediaQueryListSM.matches,
        mediaQueryListMD.matches,
        mediaQueryListLG.matches
      );
      setSkeletonCount((currentCount) =>
        currentCount === nextCount ? currentCount : nextCount
      );
    };

    updateSkeletonCount();

    mediaQueryListSM.addEventListener('change', updateSkeletonCount);
    mediaQueryListMD.addEventListener('change', updateSkeletonCount);
    mediaQueryListLG.addEventListener('change', updateSkeletonCount);

    return () => {
      mediaQueryListSM.removeEventListener('change', updateSkeletonCount);
      mediaQueryListMD.removeEventListener('change', updateSkeletonCount);
      mediaQueryListLG.removeEventListener('change', updateSkeletonCount);
    };
  }, []);

  return (
    <div className={`${styles.dateCarouselRow} ${styles.dateTabsLoaderRow}`}>
      {Array.from({ length: skeletonCount }).map((_,index) => (
        <div key={index} className={styles.dateTab}>
          <div className={`${styles.dateTabDayNum} ${styles.dateTabsDayNumLoader}`}>
            <Skeleton circle={true} />
          </div>
          <div className={`${styles.dateTabDayName} ${styles.dateTabsDayNameLoader}`}>
            <Skeleton width={34} height={14} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BookingDatesPickerLoader;
